module.exports = __webpack_public_path__ + "static/media/menu.ee2cc7f9.png";